import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  PictogramRegularPercentageDiscount,
  theme,
} from '@notino/react-styleguide';

import PriceLabel from '@components/PriceLabel';
import { useIsDualPriceForCroatia } from '@containers/ProductDetailContainer/ProductDetail/hooks/useIsDualPriceForCroatia';
import { usePriceLogic } from '@containers/ProductDetailContainer/ProductDetail/hooks/usePriceLogic';
import { getDiscountPercentage } from '@containers/ProductDetailContainer/ProductDetail/hooks/usePriceLogic/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { Line, LineWrapper } from '../../SelectedVariant/styled';

import { actionCardMessages } from './messages';
import {
  PictogramRegularPercentageDiscountWrapper,
  ActionCardInfo,
  ActionCardWrapper,
  PriceDetails,
  Slash,
  CurrencyWrapper,
  DiscountAmountWrapper,
  ActionPriceDescription,
} from './styled';

export const ActionCard = () => {
  const { currentVariant } = useProductDetailContext();

  const { topPrice } = usePriceLogic(currentVariant);

  const variantPrice = currentVariant.price;

  const {
    isDualPriceForCroatia,
    getLeftSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
    getRightSidePrice,
  } = useIsDualPriceForCroatia();

  if (!topPrice) {
    return null;
  }

  const discountPercentage = getDiscountPercentage(
    currentVariant.price.value,
    currentVariant.recentMinPrice.value
  );

  return (
    <div>
      <ActionCardWrapper>
        <ActionCardInfo>
          <PriceDetails>
            {isDualPriceForCroatia && (
              <>
                {getLeftSideFormattedPrice(variantPrice.value)}{' '}
                <CurrencyWrapper>{leftSideCurrency}</CurrencyWrapper>
                <Slash>/</Slash>
              </>
            )}
            <PriceLabel
              price={{
                value: isDualPriceForCroatia
                  ? getRightSidePrice(variantPrice.value)
                  : variantPrice.value,
              }}
              currencySymbolOverride={
                isDualPriceForCroatia ? rightSideCurrency : undefined
              }
              wrapperComponent={DiscountAmountWrapper}
              currencyComponent={CurrencyWrapper}
            />

            <ActionPriceDescription>
              <FormattedMessage
                {...actionCardMessages.actionPriceDescription}
              />
            </ActionPriceDescription>
          </PriceDetails>

          <PictogramRegularPercentageDiscountWrapper>
            <PictogramRegularPercentageDiscount
              percentage={discountPercentage}
              bgColor={theme.color.background.highlight}
            />
          </PictogramRegularPercentageDiscountWrapper>
        </ActionCardInfo>
      </ActionCardWrapper>

      <LineWrapper>
        <Line />
      </LineWrapper>
    </div>
  );
};
